import { createSelector } from 'reselect'

import { EMPTY_ARRAY } from 'utils/emptyConstants'

import { URL_STATE } from './constants'

const selectData = (state) => state.resolutioncenter.list.data
const selectLoader = (state) => state.resolutioncenter.list.loader
const selectError = (state) => state.resolutioncenter.list.error

// Guarded: `Agents/epics.js` is an ALWAYS-ON registry key that reads this
// selector, so it can run while the route-scoped `resolutioncenter` slice is
// unmounted. Same idiom as `isOnUnclassifed` below (`!!state.resolutioncenter
// && ...`), applied via optional chaining so every caller — including the
// two unguarded call sites in Agents/epics.js — gets `null`/`[]` instead of
// a TypeError.
const selectReports = (state) => state.resolutioncenter?.list?.data?.reports?.results ?? EMPTY_ARRAY

const selectSelectedReportId = (state) =>
  state.resolutioncenter?.list?.selectedReportId || selectReports(state)[0]?.id || null
const selectSelectedReportType = (state) =>
  state.resolutioncenter?.list?.selectedReportType || selectReports(state)[0]?.reportType || null

const selectUrlState = (state) => state.resolutioncenter.list.urlState

const isOnUnclassifed = (state) =>
  !!state.resolutioncenter && selectUrlState(state) === URL_STATE.UNCLASSIFIED

const selectPage = (state) => state.resolutioncenter.list.page
const selectPageJump = (state) => !!state.resolutioncenter.list.pageJump

const selectFirstPageLoadDate = (state) => state.resolutioncenter.list.firstPageLoadDate
const selectLastRowDate = (state) => state.resolutioncenter.list.lastRowDate

export const selectSelectedReport = createSelector(
  [selectReports, selectSelectedReportId],
  (reports, selectedReportId) => reports.find((report) => report.id === selectedReportId)
)

const selectReportEidsById = (state) =>
  selectReports(state).reduce((acc, result) => {
    if (result.eid) {
      acc[result.id] = result.eid
    }
    return acc
  }, {})

export {
  selectData,
  selectReports,
  selectLoader,
  selectError,
  selectSelectedReportId,
  selectSelectedReportType,
  selectUrlState,
  isOnUnclassifed,
  selectPage,
  selectPageJump,
  selectFirstPageLoadDate,
  selectLastRowDate,
  selectReportEidsById,
}
